import { getParts } from "@/pages/drawings/search-documents/repository/DocumentsRepositorie";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { get } from "lodash-es";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchParts = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllParts },
	} = useWorkOrderModalsContext();

	return async () => {
		setIsLoading(true);
		const res = await getParts();
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);

			setListAllParts(rowsSource);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setError(res.message);
		}
	};
};
